/**
 * @generated SignedSource<<be5aac0e4cf74fd15e808972051259aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditableCompanyLogoV2_organization$data = {
  readonly id: string;
  readonly logoImage: {
    readonly uid: string;
    readonly url: string;
  } | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "EditableCompanyLogoV2_organization";
};
export type EditableCompanyLogoV2_organization$key = {
  readonly " $data"?: EditableCompanyLogoV2_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditableCompanyLogoV2_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditableCompanyLogoV2_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "4cb06e76f563baa8e34374601633c950";

export default node;
